import { render } from "./ProfileNavigation.vue?vue&type=template&id=7abd52b8"
import script from "./ProfileNavigation.vue?vue&type=script&lang=js"
export * from "./ProfileNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__